import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { investmentQueryKeys } from './investmentQueryKeys'
import { getInvestment } from '../service/investmentService'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { filtersSelector } from '../../../redux/context/filters/selectors'

export const useInvestmentDetail = (investmentId?: number) => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const { budgetingScenario } = useSelector(filtersSelector)

  return useQuery({
    queryKey: investmentQueryKeys.detail({
      companyId,
      investmentId: investmentId!,
      budgetingScenarioId: budgetingScenario?.id
    }),
    queryFn: () => getInvestment(companyId, investmentId!, budgetingScenario?.id),
    enabled: !!companyId && !!investmentId
  })
}
